import type { CoolingRegimePriorityDto } from "../../../RoyalFloraHolland.Aap.Services.Api.Web.Kiota/Typescript/Api/models/index";

export interface PriorityRow {
  coolingRegimePriorityId: number;
  description: string;
  lastModified: string | null;
  lastModifiedBy: string | null;
  created: Date | null;
  createdBy: string;
  actions?: any;
}

/**
 * Maps cooling regime priority DTOs to table row format.
 * @param priorities - Array of priority DTOs from the API
 * @returns Array of priority rows for display in the table
 */
export function mapCoolingRegimePrioritiesToRows(
  priorities: CoolingRegimePriorityDto[],
): PriorityRow[] {
  return priorities.map((priority) => ({
    coolingRegimePriorityId: priority.coolingRegimePriorityId ?? 0,
    description: priority.description ?? "-",
    lastModified: priority.lastModified
      ? formatDate(new Date(priority.lastModified))
      : null,
    lastModifiedBy: priority.lastModifiedBy ?? null,
    created: priority.created ? new Date(priority.created) : null,
    createdBy: priority.createdBy ?? "-",
  }));
}

function formatDate(date: Date): string {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}
